// Lib
import React from 'react';
import ElementTool from './ElementTool';
import { ElementToolSettings, ToolbarItemConfig } from '../../toolbarTypes';

// Components

type ElementToolContainerProps = {
    item: ToolbarItemConfig;
    currentBoardId: string;
    currentUserId: string;
    gridSize: number;
    permissions: number;
};

const ElementToolContainer = ({
    item,
    currentBoardId,
    currentUserId,
    gridSize,
    permissions,
}: ElementToolContainerProps): React.ReactElement => {
    const { toolSettings } = item;
    const settings = toolSettings as ElementToolSettings;

    return (
        <ElementTool
            toolName={settings.elementTypeObject.elementType}
            name={settings.elementTypeObject?.displayName}
            elementType={settings.elementTypeObject.elementType}
            iconName={settings.elementTypeObject?.icon}
            focusInputEditorType={settings.focusInputEditorType}
            currentBoardId={currentBoardId}
            currentUserId={currentUserId}
            gridSize={gridSize}
            editOnCreate={settings.editOnCreate}
            selectOnCreate={settings.selectOnCreate}
        />
    );
};

export default ElementToolContainer;
